/* eslint-disable */
/* tslint:disable */
// @ts-ignore
import icon from 'vue-svgicon'
icon.register({
  'Social/Facebook': {
    width: 24,
    height: 24,
    viewBox: '0 0 24 24',
    data: '<path pid="0" fill-rule="evenodd" d="M20.896 2H3.104C2.494 2 2 2.494 2 3.104v17.792C2 21.506 2.494 22 3.104 22h9.58v-7.734h-2.598v-3.028h2.598V9.01c0-2.584 1.578-3.99 3.882-3.99 1.104 0 2.053.082 2.329.119v2.7h-1.59c-1.254 0-1.496.597-1.496 1.472v1.927h2.998l-.391 3.028h-2.607V22h5.087c.61 0 1.104-.494 1.104-1.104V3.104C22 2.494 21.506 2 20.896 2z"/>'
  }
})
